import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import { H2 } from 'styles/components/typography'

export const Inner = styled.div`
  background-color: ${p => p.bgColor};
`

export const Square = styled.div`
  position: fixed;
  width: ${p => p.theme.blocks.squareSize};
  height: ${p => p.theme.blocks.squareSize};
  display: flex;
  justify-content: center;
  align-items: center;
  top: ${p => math(`${p.theme.blocks.menuHeight} + ${em(20)}`)};
  overflow: hidden;

  ${p => p.theme.mq.upMd} {
    width: ${p => p.theme.blocks.squareSizeMd};
    height: ${p => p.theme.blocks.squareSizeMd};
    top: ${p => math(`${p.theme.blocks.menuHeightMd} * 2 + ${em(40)}`)};

    ${Inner} {
      width: 100%;
      height: 100%;
      transform: translateY(100%);
      position: absolute;
      z-index: -1;
    }
  }
`

export const Number = styled(H2)`
  position: absolute;
  margin-bottom: 0 !important;
  color: ${p => p.color};
  transition:
    opacity ${p => p.theme.animation.timeFastest},
    transform ${p => p.theme.animation.timeFastest};

  ${({ state }) =>
    state === 'entering' &&
    css`
      opacity: 0;
      transform: translateY(1em);
    `}

  ${({ state }) =>
    state === 'entered' &&
    css`
      opacity: 1;
      transform: translateY(0);
    `}

  ${({ state }) =>
    (state === 'exiting' || state === 'exited') &&
    css`
      opacity: 0;
      transform: translateY(1em);
    `}
`
